import React, { FC } from 'react'
import {
  Button,
  Header,
  ModalActions,
  ModalContent,
  Text,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { VendImage } from '@vend/react-utilities'
import { LSPayCardNotPresentEntryIcon } from '../../../../sale/payment-panel/lspay-entry-icons'

interface LSPAYCnpOnboardingSignpostProps {
  onDismiss: () => void
}

const CNP_ONBOARDING_HAND_POINTER_PATH =
  'payments/lspay-cnp-onboarding-hand-pointer.svg'

export const LSPAYCnpOnboardingSignpost: FC<LSPAYCnpOnboardingSignpostProps> = ({
  onDismiss,
}) => (
  <>
    <ModalContent>
      <section className="cnp-signpost">
        <div
          aria-hidden="true"
          className="cnp-signpost__illustration-container"
          data-testid="lspay-cnp-onboarding-illustration"
        >
          <div className="cnp-signpost__illustration">
            <div className="cnp-signpost__primary-button">
              <div className="cnp-signpost__button-line" />
            </div>
            <div className="cnp-signpost__split-button">
              <LSPayCardNotPresentEntryIcon
                aria-hidden="true"
                className="cnp-signpost__keyboard-icon"
                focusable="false"
              />
            </div>
            <div className="cnp-signpost__active-border" />
            <div className="cnp-signpost__secondary-button" />
            <div className="cnp-signpost__secondary-button" />
            <div className="cnp-signpost__secondary-button" />
            <VendImage
              alt=""
              aria-hidden="true"
              className="cnp-signpost__pointer"
              relativeImagePath={CNP_ONBOARDING_HAND_POINTER_PATH}
            />
          </div>
        </div>
        <div className="cnp-signpost__text">
          <Header
            className="cnp-signpost__heading"
            type="sub-heading"
            level="2"
          >
            <T
              _str="Manual card entry has a new home"
              _context="LSPay CNP split onboarding signpost heading"
            />
          </Header>
          <Text tag="p" className="cnp-signpost__body">
            <T
              _str="At checkout, select the keyboard icon on the Lightspeed Payments button."
              _context="LSPay CNP split onboarding signpost body"
            />
          </Text>
        </div>
      </section>
    </ModalContent>
    <ModalActions>
      <Button
        type="button"
        variant="go"
        data-track="dismiss-lspay-cnp-split-signpost"
        onClick={onDismiss}
      >
        <T
          _str="Don't show again"
          _context="LSPay CNP split onboarding signpost dismiss action"
        />
      </Button>
    </ModalActions>
  </>
)
